import { useEffect, useRef } from 'react'
import classnames from 'classnames/bind'
import { Swiper, SwiperSlide } from 'swiper/react'
import { isEmpty } from 'lodash-es'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

// Libs

// Components

// Constants

// Styles
import styles from './style.module.scss'

// Mock Data

const cx = classnames.bind(styles)

interface CounterProps {
  values: { role?: number; label: string; value: any }[]
  onChange: (amount: any) => void
  className?: string
  activeIndex?: number | undefined
}

const Tabs = ({ values, onChange, className, activeIndex }: CounterProps) => {
  const { t } = useTranslation()
  const swiperRef: any = useRef(null)
  const router = useRouter()

  const handleChange = (value: any) => {
    onChange(value)
  }

  // 語系資料更新，swiper 也需要重新計算
  useEffect(() => {
    if (!isEmpty(swiperRef.current) && router.locale !== 'default' && values.length > 0) {
      setTimeout(() => {
        swiperRef.current.update()
      }, 800)
    }
  }, [swiperRef.current, router.locale, values.length])

  return (
    <div className={cx('tabs', className)}>
      <Swiper
        onInit={(ref) => (swiperRef.current = ref)}
        className={cx('tabs__carousell')}
        slidesPerView='auto'
        spaceBetween={4}
        grabCursor
        breakpoints={{
          710: {
            spaceBetween: 10,
          },
        }}
      >
        {values.map((data, index) => (
          <SwiperSlide key={index} style={{ width: 'auto' }}>
            <div
              data-tab-active={index === activeIndex}
              className={cx('tabs-tab', index === activeIndex && 'active')}
              key={data.label}
              onClick={() => handleChange(data.value)}
            >
              {t(data.label)}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Tabs
